// * Icons
import SpeedRoundedIcon from "@mui/icons-material/SpeedRounded";
import CurrencyRupeeRoundedIcon from "@mui/icons-material/CurrencyRupeeRounded";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";

export default function Features() {
  return (
    <div className="featuresListBox">
      <div className="introBox">
        <p>Fastest Growing NBFC in Central Western India</p>
      </div>
      <div className="featuresList">
        <div className="feature">
          <div className="featureIcon">
            <SpeedRoundedIcon sx={{ color: "#2e3092" }} />
          </div>
          <p>Easy loan application and Hassel free process</p>
        </div>
        <div className="feature">
          <div className="featureIcon">
            <CurrencyRupeeRoundedIcon sx={{ color: "#2e3092" }} />
          </div>
          <p>Real time approval and disbursements</p>
        </div>
        <div className="feature">
          <div className="featureIcon">
            <VerifiedRoundedIcon sx={{ color: "#2e3092" }} />
          </div>
          <p>Transparent Verifications and Customized Loans</p>
        </div>
      </div>
    </div>
  );
}
